import { useMemo } from 'react'
import { CategoryBrowseTab } from '../types'
import type { CategoryTab, CategoryTabOption, Image } from '../types'
import { useTranslation } from '../../../../../hooks/locale'

export interface GallerySection {
    key: CategoryTab
    title: string
    images: Image[]
}

interface UseGallerySectionsProps {
    images: Image[]
    enableCategorizedGallery: boolean
    availableTabs: CategoryTabOption[]
    activeCategoryTab: CategoryTab
}

export const useGallerySections = ({
    images,
    enableCategorizedGallery,
    availableTabs,
    activeCategoryTab,
}: UseGallerySectionsProps) => {
    const { t } = useTranslation()
    const videoSectionTitle = t('gallery.videos')

    const imageSections = useMemo<GallerySection[]>(() => {
        if (!enableCategorizedGallery || activeCategoryTab === CategoryBrowseTab.ALL) {
            return [{ key: CategoryBrowseTab.ALL, title: t('gallery.photos'), images }]
        }

        const activeTab = availableTabs.find(tabOption => tabOption.key === activeCategoryTab)

        return [
            {
                key: activeCategoryTab,
                title: activeTab ? t(activeTab.translationKey) : t('gallery.photos'),
                images,
            },
        ]
    }, [enableCategorizedGallery, activeCategoryTab, availableTabs, images, t])

    return { videoSectionTitle, imageSections }
}
